import * as apigw from "@/lib/apigw"

export const updateMoviePlayCountDb = async (movieId?: string, opts?: any): Promise<any> => {
  const res = await apigw.request("/user/update-movie-play-count", { movieId }, opts)
  return res
}
